import React from 'react';

const SecurityBadges = ({ showInProgress = true, darkTheme = false }) => {
  const activeBadges = [
    {
      name: 'SSL Secured',
      status: 'active',
      logo: 'https://img.shields.io/badge/SSL-Secured-green?style=for-the-badge&logo=lock',
      description: 'SSL/TLS encryption via AWS Certificate Manager'
    },
    {
      name: 'Stripe Powered',
      status: 'active', 
      logo: 'https://img.shields.io/badge/Powered%20by-Stripe-635bff?style=for-the-badge&logo=stripe',
      description: 'Secure payments powered by Stripe'
    },
    {
      name: 'AWS Infrastructure',
      status: 'active',
      logo: 'https://img.shields.io/badge/Powered%20by-AWS-orange?style=for-the-badge&logo=amazon-aws', 
      description: 'Hosted on Amazon Web Services'
    }
  ];

  const progressBadges = [
    {
      name: 'PCI Compliant',
      status: 'active',
      logo: 'https://img.shields.io/badge/PCI-Compliant-green?style=for-the-badge&logo=shield',
      description: 'PCI compliance via Stripe - no card data stored'
    },
    {
      name: 'SOC 2',
      status: 'progress', 
      logo: 'https://img.shields.io/badge/SOC%202-In%20Progress-lightgrey?style=for-the-badge&logo=clipboard-check',
      description: 'SOC 2 Type II audit underway'
    },
    {
      name: 'HIPAA',
      status: 'progress',
      logo: 'https://img.shields.io/badge/HIPAA-In%20Progress-lightgrey?style=for-the-badge&logo=hospital',
      description: 'HIPAA compliance for healthcare customers'
    }
  ];

  const allBadges = showInProgress ? [...activeBadges, ...progressBadges] : activeBadges;

  return (
    <div className="flex flex-col gap-3">
      <div className={`text-base font-bold font-['Inter'] ${darkTheme ? 'text-gray-50' : 'text-gray-800'}`}>Security & Trust</div>
      <div className="flex flex-wrap gap-3">
        {allBadges.map((badge) => (
          <img
            key={badge.name}
            src={badge.logo}
            alt={badge.name}
            title={badge.description}
            className={`h-7 ${badge.status === 'progress' ? 'opacity-50' : ''}`}
          />
        ))}
      </div>
      {showInProgress && (
        <p className={`text-xs font-medium font-['Inter'] leading-5 ${darkTheme ? '!text-stone-300' : 'text-gray-500'}`}>
          PCI compliance via Stripe (no card data stored). Additional certifications in progress for enterprise customers.
        </p>
      )}
    </div>
  );
};

export default SecurityBadges;